export default {
  "yourOwnStorageRoot": "your own storage root",
  "failedToCreateTransfer": "Failed to create transfer",
  "preparationWasCancelledBeforeTheRequestWasSent": "Preparation was cancelled before the request was sent.",
  "couldNotPrepareThisTransfer": "Could not prepare this transfer.",
  "sendFilesToAnotherInstance": "Send files to another instance",
  "closeDialog": "Close dialog",
  "confirmSystemWideSend": "Confirm system-wide send",
  "confirmThisTransfer": "Confirm this transfer",
  "reviewTheBatchBelowNothingMovesUntilTheReceivingServer": "Review the batch below. Nothing moves until the receiving server approves.",
  "sending": "Sending",
  "from": "From",
  "toInstance": "To instance",
  "landsAt": "Lands at",
  "type": "Type",
  "migrationCopyNowReclaimSourceAfterLanding": "Migration (copy now — reclaim source after landing)",
  "loadBalanceCopyToTheOtherServer": "Load balance (copy to the other server)",
  "couldNotCreateTransfer": "Could not create transfer",
  "destinationInstance": "Destination instance",
  "chooseAnInstance": "Choose an instance…",
  "instanceIdOfYourOtherServer": "Instance id of your other server",
  "enterTheInstanceIdOfAnotherServerYouOwnThe": "Enter the instance id of another server you own. The receiving end approves before any data moves.",
  "whatToSend": "What to send",
  "whereItLandsOnTheRemote": "Where it lands on the remote",
  "leaveBlankToDeliverToYourOwnRoot": "Leave blank to deliver to your own root",
  "usernameOnTheReceivingServerVerifiedWhenThatServerS": "Username on the receiving server — verified when that server's admin approves. Blank delivers to your own storage root there.",
  "eGMediaMoviesDefaultsToTheTargetRoot": "e.g. media/movies — defaults to the target root",
  "aRelativeSubfolderUnderTheTargetRootTheReceiverCan": "A relative subfolder under the target root. The receiver can still adjust it when approving.",
  "or": "or",
  "anAbsolutePathOnTheReceivingServerMustAlreadyExist": "An absolute path on the receiving server — must already exist. Suggested to the receiving admin, who confirms or changes it before any data moves. Set, this overrides the user delivery above.",
  "transferType": "Transfer type",
  "copyTheFilesToTheOtherServerNowAfterThey": "Copy the files to the other server now. After they land, reclaim the source here to free this server's space.",
  "migration": "Migration",
  "copyTheFilesToTheOtherServerToSpreadLoad": "Copy the files to the other server to spread load across both.",
  "loadBalance": "Load balance",
  "whatIsThisTransfer": "What is this transfer?",
  "closeItKeepsWorking": "Close — it keeps working",
  "back": "Back",
  "sendingRequest": "Sending request…",
  "confirmSend": "Confirm & send",
  "cancel": "Cancel",
  "reviewSend": "Review & send",
  "failedToAcceptTransfer": "Failed to accept transfer",
  "failedToDeclineTransfer": "Failed to decline transfer",
  "incomingTransferRequest": "Incoming transfer request",
  "reviewBeforeAnyDataMoves": "Review before any data moves",
  "fromInstance": "From instance",
  "status": "Status",
  "files": "Files",
  "totalSize": "Total size",
  "deliverTo": "Deliver to",
  "noteFromSender": "Note from sender",
  "whereShouldThisLand": "Where should this land?",
  "aSystemDestinationHandsTheDeliveredFilesToTheAddressed": "A system destination hands the delivered files to the addressed account so it owns its own migrated data.",
  "leaveBlankToKeepRootOwned": "Leave blank to keep root-owned",
  "deliveredFilesWillLandRootOwnedNameAnAccountTo": "Delivered files will land root-owned. Name an account to hand them over — you can also re-apply ownership later from the transfer history.",
  "actionFailed": "Action failed",
  "declineThisTransferRequest": "Decline this transfer request?",
  "keep": "Keep",
  "decline": "Decline",
  "acceptStart": "Accept & start",
  "diskIO": "Disk I/O",
  "correlationDataIsNoLongerAvailableForThisTransfer": "Correlation data is no longer available for this transfer.",
  "transferThroughputCorrelatedWithHostCPUNetworkAndDiskI": "Transfer throughput correlated with host CPU, network, and disk I/O utilization over the transfer duration",
  "transferThroughputOverTheTransferDurationHostCPUNetworkAnd": "Transfer throughput over the transfer duration; host CPU, network, and disk I/O metrics are unavailable for this window",
  "hostInfraMetricsAreUnavailableForThisWindowShowingThroughput": "Host infra metrics are unavailable for this window — showing throughput only.",
  "throughputVsHostLoad": "Throughput vs host load",
  "homeStorageRoot": "Home (storage root)",
  "browsingTheWholeServerCheckAnyFilesOrFoldersTo": "Browsing the whole server. Check any files or folders to send.",
  "browsingTheWholeServerChooseAnyFolderToReceiveInto": "Browsing the whole server. Choose any folder to receive into.",
  "browsingYourOwnFilesCheckAnyFilesOrFoldersTo": "Browsing your own files. Check any files or folders to send.",
  "browsingYourOwnFilesChooseAFolderToReceiveInto": "Browsing your own files. Choose a folder to receive into.",
  "myFiles": "My files",
  "browseTheServer": "Browse the server",
  "systemWideSendAdmin": "System-wide send (admin).",
  "youAreBrowsingTheWholeServerNotJustYourOwn": "You are browsing the whole server, not just your own files. Anything you check here will be sent off this server.",
  "serverFilesCheckFilesOrFoldersToSend": "Server files (check files or folders to send)",
  "serverFilesPickADestination": "Server files (pick a destination)",
  "loading": "Loading…",
  "thisDirectoryIsEmpty": "This directory is empty.",
  "yourFilesCheckFilesOrFoldersToSend": "Your files (check files or folders to send)",
  "yourFilesPickADestination": "Your files (pick a destination)",
  "selectedFilesAndFoldersToSend": "Selected files and folders to send",
  "nothingSelectedYet": "Nothing selected yet",
  "clearAll": "Clear all",
  "checkFilesOrFoldersAboveToBuildABatch": "Check files or folders above to build a batch.",
  "homeEntireStorageRoot": "Home (entire storage root)",
  "couldNotLoadTransferDetails": "Could not load transfer details.",
  "retry": "Retry",
  "ifThisDeliveryLandedRootOwnedReApplyOwnershipSo": "If this delivery landed root-owned, re-apply ownership so the receiving account owns its migrated data.",
  "reApplyOwnership": "Re-apply ownership",
  "avgSpeed": "Avg speed",
  "peakSpeed": "Peak speed",
  "duration": "Duration",
  "reconnects": "Reconnects",
  "transferred": "Transferred",
  "verify": "Verify",
  "failure": "Failure",
  "noTelemetryRecordedForThisTransferYet": "No telemetry recorded for this transfer yet.",
  "timeline": "Timeline",
  "reclaimSourceFiles": "Reclaim source files?",
  "deleteSource": "Delete source",
  "keepSource": "Keep source",
  "this": "this",
  "sourceReclaimed": "Source reclaimed",
  "reclaimFailedSourceKept": "Reclaim failed — source kept",
  "theDeleteCouldNotCompleteTheOriginalFilesRemainOn": "The delete could not complete. The original files remain on this server.",
  "ownershipApplied": "Ownership applied",
  "removeThisTransferRecord": "Remove this transfer record?",
  "removeRecord": "Remove record",
  "historyRecord": "history record",
  "notAffected": "not affected",
  "sourceFilesAreStillOnThisServer": "source files are still on this server",
  "reclaim": "Reclaim",
  "thisCannotBeUndone": "This cannot be undone.",
  "transferRecordRemoved": "Transfer record removed",
  "filesWereNotAffected": "Files were not affected.",
  "clearTransferHistory": "Clear transfer history?",
  "clearHistory": "Clear history",
  "completedFailedCancelledAndDeclined": "completed, failed, cancelled, and declined",
  "filesAreNotAffected": "files are not affected",
  "reclaimableSourceFilesOnThisServer": "reclaimable source files on this server",
  "noRecordsToClear": "No records to clear",
  "onlyFinishedTransfersCanBeRemoved": "Only finished transfers can be removed.",
  "peer": "Peer",
  "size": "Size",
  "date": "Date",
  "sourceReclaimedTheOriginalFilesWereDeletedFromThisServer": "Source reclaimed — the original files were deleted from this server.",
  "reclaimFailedSourceKeptTheDeleteCouldNotCompleteSo": "Reclaim failed — source kept. The delete could not complete, so the original files remain on this server.",
  "removeRecordDeletesThisHistoryEntryOnlyTransferredFilesAre": "Remove record — deletes this history entry only; transferred files are not affected",
  "removeTransferRecordHistoryEntryOnlyFilesNotAffected": "Remove transfer record — history entry only, files not affected",
  "transferHistory": "Transfer history",
  "searchPeerPathOrNote": "Search peer, path, or note…",
  "searchTransferHistory": "Search transfer history",
  "filterByStatus": "Filter by status",
  "clearTransferHistoryRemovesFinishedRecordsOnlyTransferredFilesAre": "Clear transfer history — removes finished records only; transferred files are not affected",
  "clearTransferHistoryRecordsOnlyFilesNotAffected": "Clear transfer history — records only, files not affected",
  "noTransfersMatchYourFilters": "No transfers match your filters.",
  "noTransferHistoryYetFinishedTransfersAppearHereOnceThey": "No transfer history yet. Finished transfers appear here once they complete.",
  "prev": "Prev",
  "next": "Next",
  "noIncomingTransfers": "No incoming transfers",
  "whenAnotherOfYourInstancesOffersFilesTheRequestAppears": "When another of your instances offers files, the request appears here for your approval.",
  "incomingRequests": "Incoming requests",
  "refresh": "Refresh",
  "preparingYourSend": "Preparing your send",
  "buildingTheFileManifestAndChecksumsThisCanTakeA": "Building the file manifest and checksums. This can take a while for large folders — you can close this window and it keeps working.",
  "scanningTheSelection": "Scanning the selection…",
  "manifestBuildProgress": "Manifest build progress",
  "unlimited": "Unlimited",
  "reconnecting": "Reconnecting",
  "transferProgress": "Transfer progress",
  "verifyingChecksums": "Verifying checksums…",
  "transferFailed": "Transfer failed",
  "transferCancelled": "Transfer cancelled",
  "verifyingChecksums2": "Verifying checksums",
  "throughput": "Throughput",
  "eTA": "ETA",
  "filesDone": "Files done",
  "currentFile": "Current file",
  "bandwidthLimit": "Bandwidth limit",
  "transferCancelled2": "Transfer cancelled.",
  "transferCancelledYouCanCloseThisDialog": "Transfer cancelled — you can close this dialog.",
  "lostConnectionToTheTransferItMayStillBeRunning": "Lost connection to the transfer. It may still be running in the background.",
  "transferCompletedAndVerified": "Transfer completed and verified.",
  "transferFailed2": "Transfer failed.",
  "transferEnded": "Transfer ended.",
  "connectionLost": "Connection lost.",
  "streamingVerifiedChunks": "Streaming verified chunks…",
  "resume": "Resume",
  "pause": "Pause",
  "close": "Close",
  "offerAFolderToOneOfYourOtherQuickBoxInstances": "Offer a folder to one of your other QuickBox instances. The receiving end approves the request and chooses where it lands before any data is pulled — verified, resumable, and encrypted in transit.",
  "newTransfer": "New transfer",
  "pickAFolder": "Pick a folder",
  "chooseAFolderFromYourOwnStorageToOffer": "Choose a folder from your own storage to offer.",
  "receiverApproves": "Receiver approves",
  "theDestinationInstanceReviewsAndAccepts": "The destination instance reviews and accepts.",
  "verifiedPull": "Verified pull",
  "bytesStreamWithPerChunkChecksumsAndResume": "Bytes stream with per-chunk checksums and resume.",
  "yourOutgoingTransfers": "Your outgoing transfers",
  "viewProgress": "View progress",
  "yourInstances": "Your instances",
  "noOtherInstancesAreListedYetYouCanStillSend": "No other instances are listed yet. You can still send a transfer by entering an instance id manually.",
  "controlCharactersAreNotAllowed": "Control characters are not allowed.",
  "thisServerSNameWasUpdated": "This server's name was updated",
  "thisServerSNameWasResetToItsId": "This server's name was reset to its id",
  "failedToSetTheServerName": "Failed to set the server name",
  "nameThisServer": "Name this server",
  "serverName": "Server name",
  "thisNameIsSharedWithYourOtherConnectedServersWhich": "This name is shared with your other connected servers, which see it instead of the raw id. Leave blank and save to revert to the id.",
  "eGHomeMediaBox": "e.g. Home media box",
  "saveName": "Save name",
  "enterAnAbsoluteURLEGHttpsMediaExampleCom": "Enter an absolute URL, e.g. https://media.example.com",
  "onlyHttpSURLsAreAllowed": "Only http(s) URLs are allowed.",
  "enterAURLWithAHost": "Enter a URL with a host.",
  "removeTheUsernamePasswordFromTheURL": "Remove the username/password from the URL.",
  "autoAdvertisingThisServerToYourOtherServers": "Auto-advertising this server to your other servers",
  "advertisingYourCustomDashboardURL": "Advertising your custom dashboard URL",
  "notAdvertisingYourOtherServersCanTDeepLinkTo": "Not advertising — your other servers can't deep-link to this box",
  "failedToSaveTheAdvertiseSettings": "Failed to save the advertise settings",
  "advertiseSettingsSaved": "Advertise settings saved",
  "savedButNotYetPropagated": "Saved, but not yet propagated",
  "yourOtherServersMayNotSeeTheChangeUntilIt": "Your other servers may not see the change until it retries. Save again to retry.",
  "advertiseThisServer": "Advertise this server",
  "autoAdvertiseThisServer": "Auto-advertise this server",
  "publishThisServerSOwnAddressAutomaticallySoYourOther": "Publish this server’s own address automatically so your other servers can deep-link to it — no setup needed. Turn off to keep this box private.",
  "overrideTheAutoDetectedAddressWithASpecificOneFor": "Override the auto-detected address with a specific one — for example a reverse-proxy hostname. This is only your dashboard URL, never a transfer endpoint. Leave blank to use the auto-detected address.",
  "unsavedChanges": "(unsaved changes)",
  "transferSettingsSaved": "Transfer settings saved",
  "failedToSaveSettings": "Failed to save settings",
  "transferEngine": "Transfer engine",
  "loadingTransferEngineSettings": "Loading transfer engine settings…",
  "transferEngineSettingsAreManagedByTheServerAndCould": "Transfer engine settings are managed by the server and could not be loaded right now.",
  "defaultBandwidthLimit": "Default bandwidth limit",
  "appliedToNewTransfersIndividualTransfersCanStillBeRe": "Applied to new transfers. Individual transfers can still be re-capped while running.",
  "offPeakWindow": "Off-peak window",
  "restrictTransfersToADailyTimeWindowServerLocalTime": "Restrict transfers to a daily time window (server local time).",
  "enableOffPeakWindow": "Enable off-peak window",
  "to2": "To",
  "chunkSize": "Chunk size",
  "dataPort": "Data port",
  "currentDefaultCap": "Current default cap",
  "speed": "Speed",
  "waitingForRate": "Waiting for rate…",
  "instanceDirectoryUnavailable": "Instance directory unavailable",
  "failedToLoadInstances": "Failed to load instances",
  "failedToSetTheDashboardURL": "Failed to set the dashboard URL",
  "failedToBrowse": "Failed to browse",
  "transferPreparationIsNoLongerTracked": "Transfer preparation is no longer tracked",
  "lostConnectionWhilePreparing": "Lost connection while preparing",
  "stillPreparingThisIsALargeSendCloseThisAnd": "Still preparing — this is a large send. Close this and watch the Send tab.",
  "failedToLoadTransferDetail": "Failed to load transfer detail",
  "failedToLoadTransferHistory": "Failed to load transfer history",
  "transferNoLongerTracked": "Transfer no longer tracked",
  "lostConnectionToTransfer": "Lost connection to transfer",
  "transferIsTakingLongerThanExpectedCheckBackShortly": "Transfer is taking longer than expected — check back shortly.",
  "failedToStartTransfer": "Failed to start transfer",
  "noActiveTransfer": "No active transfer",
  "transferIsNotRunning": "Transfer is not running",
  "failedToUpdateTransfer": "Failed to update transfer",
  "failedToSetThrottle": "Failed to set throttle",
  "failedToLoadTransferSettings": "Failed to load transfer settings",
  "failedToUpdateSettings": "Failed to update settings",
  "notFound": "Not found",
  "failedToLoadTransfers": "Failed to load transfers",
  "failedToApproveTransfer": "Failed to approve transfer",
  "failedToRejectTransfer": "Failed to reject transfer",
  "failedToCancelTransfer": "Failed to cancel transfer",
  "failedToReclaimSource": "Failed to reclaim source",
  "failedToDeleteHistoryRecord": "Failed to delete history record",
  "failedToClearHistory": "Failed to clear history",
  "failedToApplyOwnership": "Failed to apply ownership",
  "started": "Started",
  "resumed": "Resumed",
  "reconnected": "Reconnected",
  "verifying": "Verifying",
  "verified": "Verified",
  "finished": "Finished",
  "failed": "Failed",
  "paused": "Paused",
  "preparing": "Preparing",
  "prepareFailed": "Prepare failed",
  "awaitingApproval": "Awaiting approval",
  "approved": "Approved",
  "ready": "Ready",
  "transferring": "Transferring",
  "completed": "Completed",
  "cancelled": "Cancelled",
  "declined": "Declined",
  "expired": "Expired",
  "send": "Send",
  "incoming": "Incoming",
  "history": "History",
  "settings": "Settings",
  "newIncomingTransfer": "New incoming transfer",
  "aTransferIsAwaitingYourApprovalOnTheIncomingTab": "A transfer is awaiting your approval on the Incoming tab.",
  "transferRequestSent": "Transfer request sent",
  "notEnoughFreeSpaceAtTheDestinationForThisTransfer": "Not enough free space at the destination for this transfer.",
  "transferDeclined": "Transfer declined",
  "interInstanceTransfer": "Inter-Instance Transfer",
  "moveDataBetweenYourOwnQuickBoxInstancesVerifiedResumableAnd": "Move data between your own QuickBox instances — verified, resumable, and approved by the receiving end.",
  "interInstanceTransferTabs": "Inter-instance transfer tabs",
  "itemsCount_one": "{{count}} item",
  "itemsCount_other": "{{count}} items",
  "foldersCount_one": "{{count}} folder",
  "foldersCount_other": "{{count}} folders",
  "filesCount_one": "{{count}} file",
  "filesCount_other": "{{count}} files",
  "ownedItems_one": "{{count}} item now owned by {{owner}}.",
  "ownedItems_other": "{{count}} items now owned by {{owner}}.",
  "clearedRecords_one": "Cleared {{count}} transfer record",
  "clearedRecords_other": "Cleared {{count}} transfer records",
  "reclaimTooltip_one": "Reclaim source — permanently delete the original {{count}} file ({{size}}) from this server. Cannot be undone.",
  "reclaimTooltip_other": "Reclaim source — permanently delete the original {{count}} files ({{size}}) from this server. Cannot be undone.",
  "reclaimAria_one": "Reclaim source — permanently delete {{count}} file ({{size}}) from this server",
  "reclaimAria_other": "Reclaim source — permanently delete {{count}} files ({{size}}) from this server",
  "awaitingCount_one": "{{count}} awaiting approval",
  "awaitingCount_other": "{{count}} awaiting approval",
  "remotePath": "a path on the remote: {{path}}",
  "userRoot": "{{user}}’s storage root",
  "subRoot": "{{root}}, under {{path}}",
  "addressedTo": "Addressed to {{user}}",
  "deliveredOwner": "Delivered files will be owned by {{owner}}.",
  "openEntry": "Open {{name}}",
  "summaryUnder": "{{summary}} under {{path}}",
  "removeFromBatch": "Remove {{name}} from the batch",
  "collapseEntry": "Collapse {{name}}",
  "expandEntry": "Expand {{name}}",
  "freedSpace": "Freed {{size}}.",
  "filesProgress": "{{done}} / {{total}} files",
  "reconnectAttempt": "Reconnecting (attempt {{attempt}})…",
  "maximumCharacters": "Use {{count}} characters or fewer.",
  "speedOfPeak": "Transfer speed {{speed}} of peak {{peak}}",
  "selectEntry": "Select {{name}}",
  "deselectEntry": "Deselect {{name}}",
  "openPeerTransfers": "Open {{peer}}’s transfers page",
  "suggestedDestination": "Sender suggested {{path}}. Confirm below or pick another folder.",
  "setOwnershipUser": "Set ownership to {{user}}",
  "ownershipHelp": "Hands the delivered files to {{user}} once verified. Off (the default) leaves them service-owned.",
  "ownedByUser": "Owned by {{user}}",
  "resolutionLabel": "resolution: {{resolution}}",
  "liveResolution": "live · resolution: {{resolution}}",
  "maximumBatch": "You can send up to {{count}} items in one batch. Remove some to add more.",
  "reclaimConfirmation": "This permanently deletes the original {{files}} from {{server}} server. The copy on the other instance is verified and kept. This cannot be undone.",
  "deleteHistoryHelp": "This removes only the {{record}} for this transfer. The transferred files are {{unaffected}} and remain wherever they were delivered.",
  "deleteUnreclaimedHelp": "This migration’s {{source}} and have not been reclaimed — removing the record forfeits the one-click {{reclaim}} option, and those files stay on disk.",
  "clearHistoryHelp": "This removes all {{statuses}} transfer records. Any transfer still in progress is kept. Only the records are deleted — transferred {{unaffected}}. If any completed migration still has {{source}}, clearing its record also forfeits the one-click {{reclaim}} option and those files stay on disk. This cannot be undone.",
  "toRecipient": "to {{user}}",
  "paginationRange": "Showing {{start}}–{{end}} of {{total}}",
  "fileSizeSummary": "{{files}} · {{size}}",
  "fileSizeRecipient": "{{files}} · {{size}} · for {{user}}",
  "hashedProgress": "{{done}} / {{total}} hashed",
  "reconnectOffset": "Connection dropped — reconnecting (attempt {{attempt}}) and resuming from {{offset}}.",
  "pausedOffset": "Transfer paused — resume to continue from {{offset}}.",
  "peakThroughput": "Peak {{rate}}",
  "offline": "(offline)",
  "declining": "Declining…",
  "starting": "Starting…",
  "network": "Network",
  "migrate": "Migrate",
  "balance": "Balance",
  "applying": "Applying…",
  "mismatch": "Mismatch",
  "all": "All",
  "success": "Success",
  "active": "Active",
  "sent": "Sent",
  "received": "Received",
  "review": "Review",
  "details": "Details",
  "cancelling": "Cancelling…",
  "live2": "Live",
  "reconnecting2": "Reconnecting…",
  "online": "Online",
  "offline2": "Offline",
  "saving": "Saving…",
  "save": "Save",
  "idle": "Idle",
  "fullResolution": "full",
  "bandwidthPreset": "{{count}} MB/s",
  "rate": "rate",
  "home": "Home",
  "deliverToUserOptional": "Deliver to user (optional)",
  "subfolderUnderThatRootOptional": "Subfolder under that root (optional)",
  "deliverToAPathOnTheRemoteOptional": "Deliver to a path on the remote (optional)",
  "noteForTheReceiverOptional": "Note for the receiver (optional)",
  "ownerAccountOptional": "Owner account (optional)",
  "customDashboardUrlOverride": "Custom dashboard URL (optional override)",
  "dashboardPort": "Dashboard port",
  "none": "None"
} as const;
